﻿import controller from '../../../../Resources/Scripts/_Shared/controller';

function language(context) {
  const toggleButton = context.querySelector('.aimo-language-selection__select > button');
  const selectionElement = context.querySelector('ul#language-list');
  const selectionElementLinks = selectionElement.querySelectorAll('a');

  function updateAriaAttributes(isActive) {
    toggleButton.setAttribute('aria-expanded', isActive);
    selectionElement.setAttribute('aria-hidden', !isActive);
  }

  function loopSelectionLinks(isActive) {
    for (let i = 0; i < selectionElementLinks.length; i++) {
      const singleSelectionElementLink = selectionElementLinks[i];
      if (!isActive)
        singleSelectionElementLink.setAttribute('tabindex', '-1');
      else
        singleSelectionElementLink.removeAttribute('tabindex');
    }
  }

  function init() {
    const isActive = toggleButton.classList.contains('active');
    updateAriaAttributes(isActive);
    loopSelectionLinks(isActive);

    toggleButton.addEventListener('click', function(event) {
        event.preventDefault();
        toggleButton.classList.toggle('active');
        selectionElement.classList.toggle('active');

        const isActive = toggleButton.classList.contains('active');
        updateAriaAttributes(isActive);
        loopSelectionLinks(isActive);

        if (isActive) {
            const firstOption = selectionElement.querySelector('a');
            if (firstOption) {
                firstOption.focus();
            }
            setTimeout(function () {
                document.addEventListener("click", closeLanguageSelection);
            }, 250);

            if (document.querySelector('html').classList.contains('navigation-active')) {
                const navigationWrapperElement = document.querySelector('.aimo-navigation');
                const navigationScrollHeight = navigationWrapperElement.scrollHeight;
                const navigationClientHeight = navigationWrapperElement.clientHeight;

                navigationWrapperElement.scrollTop = navigationScrollHeight - navigationClientHeight;
            }
        } else {
            document.removeEventListener("click", closeLanguageSelection);
            toggleButton.setAttribute('aria-expanded', 'false');
            selectionElement.setAttribute('aria-hidden', 'true');
            toggleButton.focus(); 
        }
    });
  }

  function closeLanguageSelection(e) {
    if (e.target !== selectionElement && !isDescendant(selectionElement, e.target)) {
      toggleButton.classList.remove('active');
      selectionElement.classList.remove('active');
      updateAriaAttributes(false);
      loopSelectionLinks(false);
      document.removeEventListener("click", closeLanguageSelection);
    }
  }

  function isDescendant(parent, child) {
    var node = child.parentNode;
    while (node !== null) {
      if (node === parent)
          return true;

      node = node.parentNode;
    }
    return false;
  }

  return {
    init
  };
}

controller.add('aimo-header-language', language);
